import { createFileRoute } from '@tanstack/react-router';

import { AdminsPage } from '@/features/owner/AdminsPage';

export const Route = createFileRoute('/_authed/owner/admins')({
  component: AdminsPage,
});
